import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";

// Import Own Components
import { apiUrl } from "Helpers";
import AuthSlice  from "Store/Slices/AuthSlice";

// Injects token in every request
const baseQuery = fetchBaseQuery({
	baseUrl        : apiUrl,
	prepareHeaders : (headers, { getState }) => {
		const { token } = getState()._authSlice;

		if (token) {
			headers.set("authorization", `Bearer ${token}`);
		}

		return headers;
	},
});

// Logs the user out if token isn't valid
const baseQueryWithReauth = async (args, api, extraOptions) => {
	const result = await baseQuery(args, api, extraOptions);

	if (result.error && result.error.status === 401) {
		api.dispatch(AuthSlice.actions.clearUserData());
	}

	return result;
};

// Retry at most 6 times.
const baseQueryWithRetry = retry(baseQueryWithReauth, { maxRetries : 6 });

export const api = createApi({
	reducerPath : "api",
	baseQuery   : baseQueryWithRetry,
	tagTypes    : ["config", "users", "dirents", "groups", "dirents", "dirents_files", "announcements"],
	endpoints   : () => ({}),
});
